<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;" >
      <Select v-model="type" style="width:150px;" @on-change="load">
        <Option value="线下课">线下课</Option>
        <Option value="线上课">线上课</Option>
      </Select>

      <cite>|</cite>
      系统每天00:05分自动生成所有课程的海报图片，<a @click="upd">点击可以立即更新</a>，更新一般在30分钟内完成
    </Card>

    <Row :gutter="16">
      <Col span="12">
        <Card  :bordered="false" dis-hover style="margin-bottom:10px;" >
          <div slot="title">一级分类</div>
          <a slot="extra" @click="load">刷新</a>
          <Button type="primary" size="small" @click="addpar">增加一级分类</Button>
          <el-table :data="list" size="small" style="width: 100%" >
            <el-table-column prop="fid" label="分类名称" :show-tooltip-when-overflow="true">
              <template slot-scope="scope" @click="load2(scope.row.i1)">
                <span v-if="scope.row.i1==pid" ><a @click="load2(scope.row.i1)"  style="color:red">{{scope.row.s1}}</a></span>
                <span v-else><a style="color:#808695" @click="load2(scope.row.i1)">{{scope.row.s1}}</a></span>
              </template>
            </el-table-column>

            <el-table-column prop="fid" label="操作" width="100">
              <template slot-scope="scope">
                <a @click="remove(scope.row.i1)">删除</a><cite>|</cite><a @click="edit(scope.row)">编辑</a>
              </template>
            </el-table-column>
          </el-table>

        </Card>
      </Col>
      <Col span="12">
      <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
        <div slot="title">二级分类</div>
        <Button type="primary" size="small" @click="addson">增加二级分类</Button>

        <el-table :data="list2" size="small" style="width: 100%" >
          <el-table-column prop="fid" label="分类名称" :show-tooltip-when-overflow="true">
            <template slot-scope="scope" @click="load2(scope.row.i1)">
              <span v-if="scope.row.i1==pid" ><a  style="color:red">{{scope.row.s1}}</a></span>
              <span v-else><a style="color:#808695">{{scope.row.s1}}</a></span>
            </template>
          </el-table-column>

          <el-table-column prop="fid" label="操作" width="100">
            <template slot-scope="scope">
              <a @click="remove(scope.row.i1)">删除</a><cite>|</cite><a @click="edit(scope.row)">编辑</a>
            </template>
          </el-table-column>
        </el-table>

      </Card>
      </Col>
    </Row>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save">
      <Form :label-width="120">
        <FormItem label="分类名称" required>
          <Input v-model="detail.name" placeholder=""/>
        </FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        baseUrl:'/api/classify/',
        list:[],//一级分类目录
        pid:0,
        list2:[],//子级目录
        detail:{name:'',pid:0},
        modal1:false,
        type:'线下课',
      }
    },
    methods:{
      edit(item){
        this.detail = {id:item.i1,name:item.s1};
        this.modal1 = true;
      },
      upd(){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要更新课程海报图片吗',
          onOk: () => {
            let that = this;
            this.$Message.info('后台已开始同步');
            this.$axios.get('/api/article/exetongbu').then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      save(){
        let that = this;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      addpar(){
        this.detail = {name:'',pid:0,type:this.type};
        this.modal1 = true;
      },
      addson(){
        if(this.pid==0){
          this.$Message.warning('请先点击左侧酒店名称，选中一个酒店，然后再增加房型');
          return;
        }
        this.detail = {name:'',pid:this.pid,type:this.type};
        this.modal1 = true;
      },
       load(){
        this.list = [];
         let that = this;
         this.$axios.get(this.baseUrl+'getparent?type='+this.type).then(function(rs){
           that.list = rs.data;
         });
       },
      load2(pid){
        this.pid = pid;
        let that = this;
        this.list2 = [];
        this.$axios.get(this.baseUrl+'getbyparent?pid='+this.pid+'&type='+this.type).then(function(rs){
          that.list2 = rs.data;
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.load2(this.pid);
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/Classify.vue